var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile-avatar',[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"alt":"Use"}}):_c('v-icon',{attrs:{"color":"primary","size":"40"}},[_vm._v("account_circle")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }